import { ResponsiveContext } from 'grommet';
import React from 'react';

export type ScreenSize = 'small' | 'medium' | 'large';
export const usePageSize = (): ScreenSize => {
    return React.useContext(ResponsiveContext) as ScreenSize;
}